<template>
  <!-- 支付 -->
  <div>
    <Header></Header>
    <div class="background">
      <div class="pay">
        <!-- 微导航 -->
        <div class="wnav" v-if="num==1">
          <span>课程体系</span> >
          <span>全部课程</span> >
          <span>全部课程</span> >
          <span class="gengduo">支付</span>
        </div>
        <div class="wnav" v-if="num==2">
          <span>测评体系</span> >
          <span>更多测评</span> >
          <span>测评详情</span> >
          <span class="gengduo">支付</span>
        </div>
        <div class="wnav" v-if="num==3">
          <span>1v1咨询</span> >
          <span>专家详情</span> >
          <span class="gengduo">支付</span>
        </div>
        <div class="inform">
          <div class="pay-inform">订单支付成功！</div>
          <div class="cont" v-for="(list,index) in lists" :key="index">
            <div class="img">
              <img src="../assets/img/cg1.png" alt />
            </div>
            <div class="money">支付金额：¥{{list.money}}</div>
            <div class="order">订单号：{{list.order}}</div>
            <div class="skip">支付成功，将在{{count}}s后跳转至主页，工作人员稍后将与您联系；</div>
            <div class="btn">
              <router-link to="/" class="btn-index">返回首页</router-link>
              <router-link to="/course" class="btn-xuexi" v-if="num==1">开始学习</router-link>
              <router-link to="/evaluation1" class="btn-xuexi" v-if="num==2">开始测评</router-link>
              <router-link to="/advisory" class="btn-xuexi" v-if="num==3">更多咨询</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
export default {
  name: "pay",
  data() {
    return {
      order_id: "",
      lists: [],
      count: "", //倒计时
      num: "" //判断是那个支付详情 1-课程 2-测评 3-咨询
    };
  },
  created() {
    this.order_id = this.$route.query.order_id;
    this.num = this.$route.query.num;
  },
  methods: {
    //  倒计时
    goGrdoupRecor() {
      const TIME_COUNT = 5;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            //跳转的页面写在此处
             this.$router.push({ path: "/"});
          }
        }, 1000);
      }
    },
    // 支付后订单信息
    async pay_succeed() {
      var uid = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .pay_succeed({ order_id: this.order_id, uid: uid.id })
        .then(res => {
          console.log(res.data.content);
          if (res.data.code == 200) {
            this.lists.push(res.data.content);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    this.pay_succeed();
    this.goGrdoupRecor();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
/* 微导航 */
.background .pay {
  width: 1200px;
  margin: 0 auto;
}
.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.pay .inform {
  width: 1200px;
  height: 828px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.pay .inform .pay-inform {
  width: 1154px;
  height: 40px;
  border-bottom: 1px solid #d8d8d8;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin: 25px 0 28px 20px;
}
.pay .inform .cont {
  width: 340px;
  margin: 0 auto;
  margin-top: 132px;
}
.pay .inform .cont .img {
  width: 134px;
  height: 125px;
  margin: 0 auto;
  margin-bottom: 16px;
}
.pay .inform .cont .money {
  width: 200px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin: 0 auto;
  margin-bottom: 6px;
}
.pay .inform .cont .order {
  width: 238px;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
  margin: 0 auto;
  margin-bottom: 16px;
}
.pay .inform .cont .skip {
  width: 256px;
  height: 26px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  margin: 0 auto;
  margin-bottom: 23px;
}
.pay .inform .cont .btn {
  width: 340px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.pay .inform .cont .btn .btn-index {
  width: 154px;
  height: 44px;
  background: rgba(255, 255, 255, 1);
  border-radius: 22px;
  border: 1px solid rgba(23, 117, 239, 1);
  font-size: 20px;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  line-height: 44px;
  text-align: center;
}
.pay .inform .cont .btn .btn-xuexi {
  width: 154px;
  height: 44px;
  background: rgba(23, 117, 239, 1);
  border-radius: 22px;
  border: 1px solid rgba(23, 117, 239, 1);
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  line-height: 44px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pay_success.vue